import React from 'react';
import classnames from 'clsx';
import {
  PackageContentDescriptionInput,
  PackageContentDescriptionLabel,
  PackageContentDescriptionInfoIcon,
  useShouldRequirePackageContentDescription,
} from '../../../../../fulfillment-planner/package-content-description';
import style from './style.module.less';

const packageContentDescriptionId = 'orders-drawer-package-content-description';

const PackageContentDescription = () => {
  const shouldRequireFormField = useShouldRequirePackageContentDescription();

  if (!shouldRequireFormField) {
    return null;
  }

  return (
    <>
      <label className={classnames(style.label, style['aligned-with-input'])} htmlFor={packageContentDescriptionId}>
        <PackageContentDescriptionLabel />
      </label>
      <PackageContentDescriptionInput id={packageContentDescriptionId} />
      <div className={classnames(style['package-content-description-info-icon'], style['aligned-with-input'])}>
        <PackageContentDescriptionInfoIcon className={style['info-icon']} tooltipPosition='left' />
      </div>
    </>
  );
};

export { PackageContentDescription };
